import { FC, HTMLAttributes } from 'react';
import Stack from '../Stack/Stack';
import './Menu.css';

interface MenuProps extends HTMLAttributes<HTMLDivElement> {}

const Menu: FC<MenuProps> = ({ children, className = '', ...props }) => {
  return (
    <Stack 
      className={`menu ${className}`} 
      gap="sm"
      {...props}
    >
      {children}
    </Stack>
  );
};

export default Menu; 